import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { SystemBanner } from '../../shared/models/system-banner/system-banner.model';

@Injectable({
	providedIn: 'root',
})
export class SystemBannerService {
	constructor(private apiService: ApiService) {
		//
	}

	getSystemBannerMessages(): Observable<SystemBanner[]> {
		return this.apiService.get('/SystemBanner/GetActiveSystemBannerMessages') as Observable<SystemBanner[]>;
	}
}
